module.exports = __webpack_public_path__ + "static/img/clearing_white_04.a00c7228.svg";